import { useState, type FormEvent, type ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../../lib/api';
import { AuthLayout, AuthField, AuthSubmit } from './AuthLayout';

export default function ForgotPassword(): ReactElement {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [devLink, setDevLink] = useState<string | null>(null);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await authApi.requestPasswordReset(email);
      setDevLink(res.devResetLink ?? null);
      setSent(true);
    } catch {
      // Bewusst still: gleiche Anzeige, egal ob E-Mail existiert.
      setSent(true);
    } finally {
      setBusy(false);
    }
  }

  if (sent) {
    return (
      <AuthLayout title="E-Mail unterwegs" subtitle="Prüfe dein Postfach.">
        <p className="text-gray-700">
          Falls ein Konto mit dieser E-Mail existiert, haben wir einen Link zum Setzen deines Passworts
          gesendet. Der Link ist 24 Stunden gültig.
        </p>
        {devLink && (
          <div className="mt-4 rounded-xl bg-amber-50 p-4 text-sm ring-1 ring-amber-100">
            <p className="mb-1 font-medium text-amber-800">Entwicklungs-Modus — Link:</p>
            <Link to={devLink.replace(/^https?:\/\/[^/]+/, '')} className="break-all text-blue-600 underline">
              {devLink}
            </Link>
          </div>
        )}
        <p className="mt-6 text-center text-sm text-gray-600">
          <Link to="/login" className="font-semibold text-blue-600 hover:text-blue-700">
            Zurück zur Anmeldung
          </Link>
        </p>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Passwort setzen oder zurücksetzen"
      subtitle="Wir senden dir einen Link, mit dem du ein neues Passwort vergibst."
    >
      <form onSubmit={handleSubmit} className="space-y-5" noValidate>
        <AuthField
          label="E-Mail-Adresse"
          type="email"
          autoComplete="email"
          value={email}
          onChange={setEmail}
          placeholder="name@firma.de"
          required
        />
        <AuthSubmit busy={busy}>Link senden</AuthSubmit>
      </form>
      <p className="mt-6 text-center text-sm text-gray-600">
        <Link to="/login" className="font-semibold text-blue-600 hover:text-blue-700">
          Zurück zur Anmeldung
        </Link>
      </p>
    </AuthLayout>
  );
}
